webpackJsonp([202548274545758],{

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/310 Final Project.d94430c4.pdf";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p1.490eb197.png";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p10.1d8cabbb.png";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p11.92949690.png";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p2.7f2d255c.png";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p3.f19bdeef.png";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p4.90583a8e.png";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p5.7baa9bb6.png";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p6.ca25eeb6.png";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p7.698073fc.png";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p8.03c72d52.png";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FutureOfTransport_p9.6750d6f1.png";

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(10);
	
	__webpack_require__(314);
	
	var _FutureOfTransport_p = __webpack_require__(516);
	
	var _FutureOfTransport_p2 = _interopRequireDefault(_FutureOfTransport_p);
	
	var _FutureOfTransport_p3 = __webpack_require__(519);
	
	var _FutureOfTransport_p4 = _interopRequireDefault(_FutureOfTransport_p3);
	
	var _FutureOfTransport_p5 = __webpack_require__(520);
	
	var _FutureOfTransport_p6 = _interopRequireDefault(_FutureOfTransport_p5);
	
	var _FutureOfTransport_p7 = __webpack_require__(521);
	
	var _FutureOfTransport_p8 = _interopRequireDefault(_FutureOfTransport_p7);
	
	var _FutureOfTransport_p9 = __webpack_require__(522);
	
	var _FutureOfTransport_p10 = _interopRequireDefault(_FutureOfTransport_p9);
	
	var _FutureOfTransport_p11 = __webpack_require__(523);
	
	var _FutureOfTransport_p12 = _interopRequireDefault(_FutureOfTransport_p11);
	
	var _FutureOfTransport_p13 = __webpack_require__(524);
	
	var _FutureOfTransport_p14 = _interopRequireDefault(_FutureOfTransport_p13);
	
	var _FutureOfTransport_p15 = __webpack_require__(525);
	
	var _FutureOfTransport_p16 = _interopRequireDefault(_FutureOfTransport_p15);
	
	var _FutureOfTransport_p17 = __webpack_require__(526);
	
	var _FutureOfTransport_p18 = _interopRequireDefault(_FutureOfTransport_p17);
	
	var _FutureOfTransport_p19 = __webpack_require__(517);
	
	var _FutureOfTransport_p20 = _interopRequireDefault(_FutureOfTransport_p19);
	
	var _FutureOfTransport_p21 = __webpack_require__(518);
	
	var _FutureOfTransport_p22 = _interopRequireDefault(_FutureOfTransport_p21);
	
	var _FinalProject = __webpack_require__(331);
	
	var _FinalProject2 = _interopRequireDefault(_FinalProject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'WorkDetail' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      ' The Future of Transportation '
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      ' INSPIRATION '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The following work is my final project for a class I took called Technical Writing during the fall semester of my senior year at Washington University in St. Louis.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We were tasked with creating anything: with taking a concept that had been nagging us in the back of our minds, and transforming that into something physical that we could hold.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      ' WHAT IS IT? '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I made a mock magazine article for a magazine called Popular Mechanics -- I wrote about the future of high speed rail and green transportation in America, as well as the roadblocks we will face along the way in the realization of these technologies.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Read from the pages below, or'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        {
	          className: 'pdfButton',
	          rel: 'noopener noreferrer',
	          href: _FinalProject2.default,
	          target: '_blank' },
	        'click here to view the pdf!'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      ' TECHNOLOGIES USED '
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Adobe InDesign'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Adobe Illustrator'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-high-speed-rail-js-d83d4f6d9f0809225d2c.js